export default function Technology() {
  const features = [
    {
      id: 1,
      icon: 'ri-speed-line',
      title: 'Yüksek Hız Üretim',
      description: 'HP Indigo ve Durst Tau dijital baskı makinelerimiz saatte 10.000 adete ulaşan üretim kapasitesiyle çalışıyor. Büyük hacimlerde flekso hattımız devreye giriyor; acil siparişlerinizde 24 saat içinde kargo garantisi asla değişmiyor.',
      stat: '10.000',
      statLabel: 'Etiket/Saat'
    },
    {
      id: 2,
      icon: 'ri-palette-line',
      title: 'Renk Mükemmelliği',
      description: 'Pantone onaylı 12 renk baskı sistemimiz, her siparişte aynı rengi üretmek için spektrofotometre ile kalibrasyon yapıyor. CMYK\'nın ötesinde metalik, floresan ve canlı beyaz mürekkep seçenekleriyle rakiplerinizden ayrışın.',
      stat: '12',
      statLabel: 'Renk Baskı'
    },
    {
      id: 3,
      icon: 'ri-truck-line',
      title: 'Güvenli Teslimat',
      description: 'Üretim tamamlanan siparişler aynı gün kargo sürecine alınıyor. İstanbul içi kurye ile ofise veya üretime teslim seçeneği mevcut. Türkiye\'nin 81 iline anlaşmalı kargo ağımızla güvenli ulaşım.',
      stat: '24',
      statLabel: 'Saat Teslimat'
    }
  ];

  return (
    <section id="technology" className="py-24 bg-[#1A2332] relative overflow-hidden">
      {/* Arka Plan Deseni */}
      <div className="absolute inset-0 opacity-5 pointer-events-none">
        <div className="absolute top-0 left-0 w-96 h-96 bg-[#FF6B35] rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#FF6B35] rounded-full blur-3xl"></div>
      </div>
      
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        {/* Başlık */}
        <div className="text-center mb-16">
          <div className="inline-block mb-4">
            <span className="text-sm font-semibold tracking-widest text-[#FF6B35] uppercase">
              Teknoloji ve Kalite
            </span>
          </div>
          <h2 className="text-5xl lg:text-6xl font-bold text-white leading-tight max-w-4xl mx-auto">
            Modern Teknoloji ile Fark Yaratıyoruz
          </h2>
          <p className="text-lg text-gray-400 mt-6 max-w-2xl mx-auto">
            Son teknoloji etiket baskı makinelerimiz ve deneyimli ekibimizle sektörde öncü konumdayız. Kalite ve hız bir arada.
          </p>
        </div>
        
        {/* Özellik Kartları */}
        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature) => (
            <div 
              key={feature.id}
              className="group bg-white/5 backdrop-blur-sm rounded-3xl p-8 hover:bg-white/10 transition-all duration-500 border border-white/10"
            >
              {/* İkon */}
              <div className="w-16 h-16 bg-[#FF6B35]/20 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className={`${feature.icon} text-4xl text-[#FF6B35]`}></i>
              </div>
              
              {/* Başlık */}
              <h3 className="text-2xl font-semibold text-white mb-4">
                {feature.title}
              </h3>
              
              {/* Açıklama */}
              <p className="text-base text-gray-400 leading-relaxed mb-6">
                {feature.description}
              </p>
              
              {/* İstatistik */}
              <div className="pt-6 border-t border-white/10">
                <div className="text-5xl font-bold text-[#FF6B35] mb-2">
                  {feature.stat}
                </div>
                <div className="text-sm text-gray-400 uppercase tracking-wide">
                  {feature.statLabel}
                </div>
              </div>
            </div>
          ))}
        </div>
        
        {/* Alt Bilgi Bandı */}
        <div className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="text-center">
            <div className="text-3xl font-bold text-white mb-2">20+</div>
            <div className="text-sm text-gray-400">Yıllık Deneyim</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-bold text-white mb-2">800+</div>
            <div className="text-sm text-gray-400">Mutlu Müşteri</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-bold text-white mb-2">2M+</div>
            <div className="text-sm text-gray-400">Üretilen Etiket</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-bold text-white mb-2">%98</div>
            <div className="text-sm text-gray-400">Müşteri Memnuniyeti</div>
          </div>
        </div>
      </div>
    </section>
  );
}